/*
|-------------------------------------------------------------------------------
| Vuex modules/cancellation.js
|-------------------------------------------------------------------------------
| Vuex data store for axios cancellation
*/

export const cancellation = {
    namespaced: true,
    state: {
        cancelTokens: [],
    },
    actions: {
        cancelPendingRequests({ state, commit }) {
            // Cancel all request where a token exists
            state.cancelTokens.forEach((request, i) => {
                if (request.cancel) {
                    request.cancel();
                }
            });

            // Reset the cancelTokens store
            commit('clearCancelTokens');
        },
    },
    mutations: {
        addCancelTokens(state, token) {
            state.cancelTokens.push(token);
        },
        clearCancelTokens(state) {
            state.cancelTokens = [];
        },
    },
    getters: {
        cancelTokens: (state) => state.cancelTokens,
    },
};
